import { LocalStorageKeys } from './localstorage.constants';

export type Keys = keyof typeof LocalStorageKeys;

export type SetItem = {
    key: Keys
    value: any
};

export const useLocalStorage = () => {
    const setItem = ({
        key, value
    }: SetItem) => {
        try {
            window.localStorage.setItem(key, JSON.stringify(value));
        } catch(error) {
            console.error(error);
        }
    };
    const getItem = (key: Keys) => {
        try {
            const item = window.localStorage.getItem(key);

            if (item) {
                return JSON.parse(item);
            }

            return undefined;
        } catch(error) {
            console.error(error);
        }
    };
    const removeItem = (key: Keys) => {
        try {
            window.localStorage.removeItem(key);
        } catch(error) {
            console.error(error);
        }
    };

    return {
        setItem,
        getItem,
        removeItem
    };
};
